export enum UploadStatus {
  UPLOADED = 'Uploaded',
  UPLOADING = 'Uploading',
  FAILED = 'Fail uploading',
  DELETED = 'Deleted',
}

type UploadStatusType = {
  status: UploadStatus;
  description?: string;
};

export default UploadStatusType;
